// extracted by mini-css-extract-plugin
export var anchor = "navbar-module--anchor--22Frm";
export var nav = "navbar-module--nav--d51wL";
export var navItems = "navbar-module--nav-items--j-VjK";
export var navItems__item = "navbar-module--nav-items__item--1iaak";
export var textFadeTransition = "navbar-module--text-fade-transition--1Eh66";